//@ts-nocheck
import React from 'react';
import { withRouter } from 'react-router-dom';
import { ReturnButton } from 'src/components/Buttons';
import { SigningDocumentCover } from 'src/components/Cover';
import { SigneesCard } from 'src/components/PortalList/PortalSigneesCard';
import { SigningCaseDetails } from 'src/components/PortalList/PortalSigningCaseDetails';
import { getSigningCaseListPath } from './utils/getSigningCaseListPath';
import { CoverWrapper } from 'src/components/Cover/styles.ts';
import { useUrlParameterCheck } from 'src/utils/useUrlParameterCheck';

const Case = props => {
  const { match } = props;
  const isFromMvpApp = useUrlParameterCheck('/app');

  return (
    <>
      {isFromMvpApp ? null : (
        <CoverWrapper>
          <SigningDocumentCover />
        </CoverWrapper>
      )}
      <SigningCaseDetails />
      {isFromMvpApp ? null : (
        <>
          <SigneesCard />
          <ReturnButton
            linkProps={{
              to: getSigningCaseListPath(match.path),
            }}
          />
        </>
      )}
    </>
  );
};

export default withRouter(Case);
